import Languages from './i18n/Languages';

/**
 * Builds a mapping of available languages for picker options
 *
 * @param {string[]} options - options of 'languages'
 * @returns
 */
const getStaticLanguages = (options) => {
    const map = options.reduce(
        (finalMap, languageKey) => ({
            ...finalMap,
            [languageKey]: Languages[languageKey].label,
        }),
        {},
    );
    return map;
};

export default getStaticLanguages;
